#include<Filter>
#include<Fog>

precision highp float;
uniform sampler2D textureMouseTrail;
uniform float useDEAA;

uniform vec3 lightRotHeight;

// Different light algorythm
// https://www.shadertoy.com/view/Dt33zM
float LIGHT_DIST = 100.;

vec3 getDiffuse(vec3 objectColor)
{
    vec3 lightPos = vec3(lightRotHeight.xy, -LIGHT_DIST);
    vec3 lightColor = vec3(1., 1., 1.);
    // ambient
    float ambientStrength = lightRotHeight.z;
    vec3 ambient = ambientStrength * lightColor;
  	
    // diffuse 
    vec3 norm = normalize(vNormalW);
    vec3 lightDir = normalize(lightPos - vec3(vPositionW));
    float diff = max(dot(norm, lightDir), 0.0);
    vec3 diffuse = diff * lightColor;
    
    // specular
    // float specularStrength = 0.5;
    
    // vec3 reflectDir = reflect(-lightDir, norm);  
    // float spec = pow(max(dot(cameraNormal, reflectDir), 0.0), 32);
    // vec3 specular = specularStrength * spec * lightColor;  
    // vec3 specular = specularStrength * lightColor;  

    // Point light
    // attenuation = max(0., 1.0 - length(direction) / range);
        
    // return (ambient + diffuse + specular) * objectColor;

    return min(ambient + diffuse, 1.) * objectColor;
} 

// Fix Aliasing
// From https://twitter.com/luruke/status/1638489004721991680?s=21&t=R-4m8kH2VPM6totpfvCrIA
float aastep(float threshold, float value) {
    float afwidth = length(vec2(dFdx(value), dFdy(value))) * 0.707;
    // float afwidth = fwidth(value);
    return smoothstep(threshold - afwidth, threshold+afwidth, value);
}

// DEAA for Distance to Edge Anti Aliasing
float DEAA() {
    float alpha = 1.;
    float cut = 0.001;
    alpha *= aastep(cut, vUV.x);
    alpha *= 1. - aastep(1. - cut, vUV.x);
    alpha *= aastep(cut, vUV.y);
    alpha *= 1. - aastep(1. - cut, vUV.y);
    return alpha;
}

void main(void) {
    vec2 mouseTrailUV = gl_FragCoord.xy / resolution;
    mouseTrailUV *= hardwareScaling;
    vec4 circleMask = texture2D(textureMouseTrail, mouseTrailUV);
    float trailMouseMask = circleMask.r;
    vec4 furyImage = getFuryImage(trailMouseMask);
    vec3 furyImageWithDiffuse = furyImage.rgb;
    if (lightRotHeight.z != 1.)  {
        furyImageWithDiffuse = getDiffuse(furyImage.rgb);
    }
    vec3 furyImageWithFog = getFogColor(furyImageWithDiffuse); 

    // FIX Aliasing
    if (useDEAA == 1.) {
        float deaa = DEAA();
        furyImage.a *= deaa;
    }

    gl_FragColor = vec4(furyImageWithFog, furyImage.a); 
}